import { render, staticRenderFns } from "./MealDetailMulti.vue?vue&type=template&id=2733fdf5&"
import script from "./MealDetailMulti.vue?vue&type=script&lang=js&"
export * from "./MealDetailMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports